import { Button } from "@mui/material";
import { Navigation } from "lucide-react";
import { CurrencyDisplay } from "../Components/currency-display";
import { MonsterCard } from "../Components/monster-card";
import { ProgressBar } from "../Components/progress-bars";
import { ResourceCounter } from "../Components/resource-counter";
import { useNavigate } from "react-router-dom";

export default function Inventory() {
  const navigate = useNavigate();
  const tele = window.Telegram.WebApp;

  tele.BackButton.show();
  tele.BackButton.onClick(() => handleBackBtn());

  const handleBackBtn = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-purple-50 pb-24">
      <CurrencyDisplay />

      <div className="max-w-md mx-auto px-4 space-y-6">
        <MonsterCard
          id="123456"
          type="Common"
          health="100/100"
          level={20}
          imageUrl="/images/seed-go/seed-nft.png"
        />

        <div className="flex gap-4">
          <ResourceCounter
            icon="/images/seed-go/seed-nft.png"
            type="SEEDmons"
            count={25}
          />
          <ResourceCounter
            icon="/images/seed-go/seed-nft.png"
            type="SEEDtrees"
            count={25}
          />
        </div>

        <div className="space-y-3">
          <ProgressBar current={22} max={30} color="bg-yellow-100" />
          <ProgressBar current={10} max={10} color="bg-green-300" />
        </div>

        <Button className="w-full bg-green-500 hover:bg-green-600 text-white text-xl py-6 rounded-full">
          Discovery
        </Button>

        <div className="text-center">
          <div className="text-gray-600 underline">
            How to play?
          </div>
        </div>
      </div>

      <Navigation />
    </div>
  );
}
